/* Copyright (c) 2026. Amazon.com, Inc. or its affiliates. All rights reserved. */

import { noop, type Unsubscribe } from '@amazon/vinyl-util'

/**
 * Installs from a module loaded off the boot chunk. The returned disposer wins both ways: disposing
 * before the load lands installs nothing, and disposing after removes what was installed.
 */
export function installLazily<M>(
    load: Promise<M>,
    install: (module: M) => Unsubscribe,
    errorHandler: (error: Error) => void
): Unsubscribe {
    let uninstall: Unsubscribe = noop
    let disposed = false
    load.then((module) => {
        if (!disposed) uninstall = install(module)
    }).catch(errorHandler)
    return () => {
        disposed = true
        uninstall()
    }
}
